import { useState } from 'react';
import type { State } from '../api.js';
import { api } from '../api.js';
import { t } from '../i18n.js';

type Choice = 'home' | 'away' | 'auto';

interface Props {
  state: State;
  onClose: () => void;
}

export function PresenceSheet({ state, onClose }: Props) {
  const initial: Choice =
    state.presence?.forced === 1
      ? state.presence.at_home === 1 ? 'home' : 'away'
      : 'auto';
  const [choice, setChoice] = useState<Choice>(initial);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const submit = async () => {
    setBusy(true);
    setErr(null);
    try {
      if (choice === 'home') await api.setPresence(true);
      else if (choice === 'away') await api.setPresence(false);
      else await api.clearPresence();
      onClose();
    } catch {
      setErr(t('presence.failed'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="sheet-overlay" onClick={onClose}>
      <div className="sheet" onClick={(e) => e.stopPropagation()} role="dialog" aria-label={t('presence.title')}>
        <div className="sheet-grab" />
        <div className="sheet-title">{t('presence.title')}</div>
        <div className="presence-opts">
          <button
            className={`presence-opt${choice === 'home' ? ' is-active' : ''}`}
            onClick={() => setChoice('home')}
            disabled={busy}
          >
            <div className="presence-opt-icon">🏠</div>
            <div className="presence-opt-label">{t('presence.home')}</div>
            <div className="presence-opt-sub">{t('presence.forced')}</div>
          </button>
          <button
            className={`presence-opt${choice === 'away' ? ' is-active' : ''}`}
            onClick={() => setChoice('away')}
            disabled={busy}
          >
            <div className="presence-opt-icon">✈</div>
            <div className="presence-opt-label">{t('presence.away')}</div>
            <div className="presence-opt-sub">{t('presence.forced')}</div>
          </button>
          <button
            className={`presence-opt${choice === 'auto' ? ' is-active' : ''}`}
            onClick={() => setChoice('auto')}
            disabled={busy}
          >
            <div className="presence-opt-icon">📍</div>
            <div className="presence-opt-label">{t('presence.auto')}</div>
            <div className="presence-opt-sub">{t('presence.geofence')}</div>
          </button>
        </div>
        {err && <div style={{ color: 'var(--danger)', textAlign: 'center', marginTop: 10, fontSize: 13 }}>{err}</div>}
        <button className="sheet-cta" onClick={() => void submit()} disabled={busy}>
          {busy ? t('presence.applying') : t('presence.apply')}
        </button>
      </div>
    </div>
  );
}
